import { render, staticRenderFns } from "./viewInvolved.vue?vue&type=template&id=51b45dfd"
import script from "./viewInvolved.vue?vue&type=script&lang=js"
export * from "./viewInvolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports